(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-full-lineup"] && !Shopify.designMode) return;
  try {
    
  class CollectionFullLineup extends HTMLElement {
    constructor() {
      super();
      this.setupQuantityControls();
      this.setupAddToCart();
    }

    setupQuantityControls() {
      this.querySelectorAll('.collection-full-lineup__quantity').forEach(quantityEl => {
        const input = quantityEl.querySelector('.collection-full-lineup__quantity-input');
        const decreaseBtn = quantityEl.querySelector('[data-action="decrease"]');
        const increaseBtn = quantityEl.querySelector('[data-action="increase"]');

        decreaseBtn?.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > 1) {
            input.value = currentValue - 1;
          }
        });

        increaseBtn?.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          input.value = currentValue + 1;
        });

        input?.addEventListener('change', (e) => {
          const value = parseInt(e.target.value) || 1;
          e.target.value = Math.max(1, value);
        });
      });
    }

    setupAddToCart() {
      this.querySelectorAll('.collection-full-lineup__add-to-cart').forEach(button => {
        button.addEventListener('click', async (e) => {
          const card = e.target.closest('.collection-full-lineup__product-card');
          const quantityInput = card.querySelector('.collection-full-lineup__quantity-input');
          const quantity = parseInt(quantityInput?.value) || 1;
          const variantId = e.target.dataset.variantId;

          if (!variantId) return;

          try {
            button.disabled = true;
            button.textContent = 'Adding...';

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: variantId,
                quantity: quantity
              })
            });

            if (response.ok) {
              button.textContent = 'Added!';
              
              // Trigger cart update event
              document.dispatchEvent(new CustomEvent('cart:updated'));
              
              setTimeout(() => {
                button.textContent = 'Add to Cart';
                button.disabled = false;
              }, 2000);
            } else {
              throw new Error('Failed to add to cart');
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
            button.textContent = 'Error';
            setTimeout(() => {
              button.textContent = 'Add to Cart';
              button.disabled = false;
            }, 2000);
          }
        });
      });
    }
  }

  customElements.define('collection-full-lineup', CollectionFullLineup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
